import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';
import moment from 'moment';

import { Card, Typography } from 'antd';
import CriteriaForm from './CriteriaForm';

import SlsOrdFulfillmentChartActions from '../../Stores/SlsOrdFulfillmentChart/Actions';
import SlsOrdFulfillmentChart from './SlsOrdFulfillmentChart';

const { Text } = Typography;

class SlsOrdFulfillmentChartScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, resetTimestamp } = this.props;

    if (curSiteFlowId > 0) {
      resetTimestamp();
    }
  }

  componentDidUpdate(prevProps) {
    const { fetchSlsOrdFulfillmentChart, curSiteFlowId, resetTimestamp, criteria } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      resetTimestamp();
    }

    if (changed('timestamp')) {
      if (curSiteFlowId > 0) {
        fetchSlsOrdFulfillmentChart(criteria);
      }
    }
  }

  render() {
    const { intl, timestamp } = this.props;

    return (
      <Card
        title={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <>
            <Text>{intl.formatMessage({ id: 'sls_ord_fulfillment' })}</Text>
            <br />
            <small>
              {`${intl.formatMessage({ id: 'last_updated' })} ${moment(timestamp).format(
                'YYYY-MM-DD HH:mm:ss'
              )}`}
            </small>
          </>
        }
      >
        <CriteriaForm />
        <SlsOrdFulfillmentChart />
      </Card>
    );
  }
}

SlsOrdFulfillmentChartScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  timestamp: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  criteria: PropTypes.object,

  resetTimestamp: PropTypes.func,
  fetchSlsOrdFulfillmentChart: PropTypes.func,

  curSiteFlowId: PropTypes.number
};

SlsOrdFulfillmentChartScreen.defaultProps = {
  intl: {},
  timestamp: 0,

  criteria: {},

  resetTimestamp() {},
  fetchSlsOrdFulfillmentChart: () => {},

  curSiteFlowId: 0
};

const mapStateToProps = state => {
  return {
    timestamp: state.slsOrdFulfillmentChart.slsOrdFulfillmentChartTimestamp,
    criteria: state.slsOrdFulfillmentChart.criteria,
    curSiteFlowId: state.app.curSiteFlowId
  };
};

const mapDispatchToProps = dispatch => ({
  resetTimestamp: () =>
    dispatch(SlsOrdFulfillmentChartActions.slsOrdFulfillmentChartResetTimestamp()),
  fetchSlsOrdFulfillmentChart: filters =>
    dispatch(SlsOrdFulfillmentChartActions.slsOrdFulfillmentChartFetch(filters))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(SlsOrdFulfillmentChartScreen));
